import { OFFERS_PER_SEARCH } from './offersPerSearch'

export const defaultPagination = {
	limit: OFFERS_PER_SEARCH,
	offset: 0
}
